'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = require('react');
var PropTypes = React.PropTypes;

var ReactSelect = require('react-select');

var Select = function (_React$Component) {
  _inherits(Select, _React$Component);

  function Select() {
    _classCallCheck(this, Select);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Select.prototype.render = function render() {
    return React.createElement(
      'div',
      { className: 'cf-select' },
      this.props.label && React.createElement(
        'label',
        null,
        this.props.label
      ),
      React.createElement(ReactSelect
      // Simplify if this isnt a searchable select
      , { searchable: this.props.searchable,
        clearable: this.props.searchable,
        backspaceRemoves: this.props.searchable,

        onChange: this.props.onChange,
        onBlur: this.props.onBlur,
        onFocus: this.props.onFocus,

        multi: this.props.multi,
        value: this.props.value,
        options: this.props.options,
        placeholder: this.props.placeholder })
    );
  };

  return Select;
}(React.Component);

Select.propTypes = {
  label: PropTypes.string,

  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,

  multi: PropTypes.bool,
  searchable: PropTypes.bool,

  value: PropTypes.any,
  options: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.any.isRequired
  })),
  placeholder: PropTypes.string
};
Select.defaultProps = {
  multi: false,
  searchable: false
};
;

module.exports = Select;